import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';

import connectToDatoCms from './connectToDatoCms';
import './style.scss';
import { STRINGS } from '../../landing/src/store/unicode';

@connectToDatoCms(plugin => ({
  developmentMode: plugin.parameters.global.developmentMode,
  fieldValue: plugin.getFieldValue(plugin.fieldPath)
}))

export default class Main extends Component {
  static propTypes = {
    fieldValue: PropTypes.string.isRequired
  };

  handleEditorChange = (content, editor) => {
    console.log('Content was updated:', content);
    this.props.plugin.setFieldValue(this.props.plugin.fieldPath, content);
  };

  setup = (editor) => {
    console.log('running setup', editor);
    editor.on('BeforeSetContent', function(e) {
      if (e.content.startsWith('<table ')) {
        e.content = '<div class="table-wrapper">' + e.content + '</div>';
      }
    });
    /* CTA */
    const blue = `<p class='cta-button'><a class='cta-button-a cta-button-a-blue' href='' target='_self'>LINK ICI</a></p>`;
    const red = `<p class='cta-button'><a class='cta-button-a cta-button-a-red' href='' target='_self'>LINK ICI</a></p>`;
    editor.addMenuItem('Blue', {
      text: 'Bleu',
      context: 'cta',
      classes: 'cta-button',
      onclick: () => {
        editor.insertContent(blue);
      }
    });
    editor.addMenuItem('Red', {
      text: 'Rouge',
      context: 'cta',
      onclick: function() {
        editor.insertContent(red);
      }
    });

    /* INFO BOXES */
    editor.addMenuItem('Info', {
      text: 'Le saviez-vous',
      context: 'info',
      onclick: function() {
        editor.insertContent(
          makeInfoBox('info-content', 'Le saviez-vous ?')
        );
      }
    });
    editor.addMenuItem('BlueInfo', {
      text: STRINGS.BON_A_SAVOIR,
      context: 'info',
      onclick: function() {
        editor.insertContent(
          makeInfoBox('blue-info-box', STRINGS.BON_A_SAVOIR)
        );
      }
    });
    editor.addMenuItem('Notify', {
      text: 'Information importante',
      context: 'info',
      onclick: function() {
        editor.insertContent(
          makeInfoBox('notify-box', 'Information importante')
        );
      }
    });

    /* QUOTES */
    const quotes = `<p class='editor-quotes'>${STRINGS.INSERER_TEXT_ICI}</p>`;
    editor.addMenuItem('quotes', {
      text: 'Big quotes',
      context: 'quotes',
      onclick: function() {
        editor.insertContent(quotes);
      }
    });
    const blockquote = `<p class='blockquote'><em>${STRINGS.INSERER_TEXT_ICI}</em></p>`;
    editor.addMenuItem('blockquotes', {
      text: 'Blockquote',
      context: 'quotes',
      onclick: function() {
        editor.insertContent(blockquote);
      }
    });

    /* Read More link */
    const readMore = `<p><a class='statut-read-more-link' href='' target='_blank'>Pour en savoir plus</a></p>`;
    editor.addMenuItem('readMore', {
      text: 'Lire plus',
      context: 'links',
      onclick: function() {
        editor.insertContent(readMore);
      }
    });

    /* Sources box */
    const sources = `<article class='article-sources'><h6>Sources</h6></article>`;
    editor.addMenuItem('sources', {
      text: 'Sources',
      context: 'links',
      onclick: function() {
        editor.insertContent(sources);
      }
    });

    /* Sources link */
    const sourcesLink = `<p><a href='#' target='_blank'>Liens</a></p>`;
    editor.addMenuItem('sourcesLink', {
      text: 'Sources Liens',
      context: 'links',
      onclick() {
        editor.insertContent(sourcesLink);
      }
    });

    function makeInfoBox(className, text) {
      const str = `<article class='info-box ${className}'>
                        <p class='info-box-icon'></p>
                        <p class='inline-block'>${text}</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus blanditiis doloribus quaerat quidem repellendus sint, velit voluptatem! Ab alias exercitationem fugiat harum necessitatibus nobis quod repellendus reprehenderit! Consequuntur, et hic!</p>
                        <button class='jump-out'></button>
                      </article><p></p>`;
      return str;
    }
  };

  render() {
    const { fieldValue } = this.props;
    return (
      <div className='container live-editor-content-style kb-table'>
        <Editor
          value={fieldValue}
          inline={true}
          init={{
            height: 500,
            menubar: 'edit view format cta table info quotes links',
            body_class: 'live-editor-content-style kb-table',
            plugins:
              'link code lists advlist textcolor colorpicker image table paste',
            init_instance_callback: this.setup,
            paste_as_text: false,
            force_br_newlines: true,
            force_span_newlines: false,
            force_p_newlines: true,
            forced_root_block: '',
            menu: {
              cta: { title: 'Boutons', items: 'Blue Red' },
              info: { title: 'Notifications', items: 'Info BlueInfo Notify' },
              quotes: { title: STRINGS.TEMOIGNAGE, items: 'quotes blockquotes' },
              links: { title: 'Liens', items: 'readMore sources sourcesLink' }
            },
            table_toolbar:
              'tablemergecells tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | tableprop',
            table_class_list: [
              { title: 'Normal', value: 'kb-table-default-style kb-table-normal' }
            ],

            toolbar:
              'formatselect | fontsizeselect | alignleft aligncenter alignright | underline bold italic | > link | bullist numlist | code | image 30% 50% 100% | table | ?'
          }}
          onEditorChange={this.handleEditorChange}
        />
      </div>
    );
  }
}
